import React, {Component} from 'react'

import PropTypes from "prop-types";

import CountrySelect from 'react-bootstrap-country-select';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-country-select/dist/react-bootstrap-country-select.css';
import DatePicker from "react-datepicker";
import Error from "../single_components/Error";
import axios from "axios";
import Select from "react-select";
import PatientSelectComponent from "../single_components/PatientSelectComponent";

const cities = require('countries-cities');

class LeumitSelfContactDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            recommendationLetter: false,
            checkboxes: this.props.checkboxes,
            cityList: this.props.cityList,
            israelCities: this.props.israelCities,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }
    async componentDidMount() {

        this.setState({recommendationLetter: this.state.entry.RecommendationLetter === "Yes"})
    }

    onClickRecommendationLetter(event) {
        this.setState({recommendationLetter: event.target.value === "Yes"})
        this.props.onValueChange("RecommendationLetter", event.target.value)

    }

    countryChange = (value) => {
        let {cityList} = this.state
        if (value) {
            this.props.onValueChange("Country_Id", value.id)
            this.props.onValueChange("Country", value.name)
            cityList = cities.getCities(value.name)
        } else {
            this.props.onValueChange("Country", "")
            this.props.onValueChange("Country_Id", "")
            cityList = []
        }
        this.setState({cityList})
    }

    onclickCountry(value) {
        if (value === "No") {
            this.props.onValueChange("Birth_country", "")
        } else {
            this.props.onValueChange("Birth_country", "Israel")
        }
        this.props.onYesNoValueChange("BornInIsrael", value)
    }

    handleCity(event){
        this.props.onValueChange("cityID", event.value.toString())
        this.props.onValueChange("SelectedCity", event)
    }

    render() {
        let {t} = this.props
        let {entry, checkboxes} = this.state

        let {israelCities} = this.props
        let cities=[]
        for(let i=0;i<israelCities.length;i++){
            cities.push({value:israelCities[i].index, label:israelCities[i].cityName})
        }


        return (
            <div className={'patientsFormBoxes'} id={'patientsFormRow'}>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}> {t('patient_self_boarding.country')}</label>
                        {/*  <CountrySelect className={'inputBoxStyle'}
                                       value= {entry.Country_Id} onChange={(event) => this.countryChange(event)} flags={false}/>*/}
                        <select className={'selectBox'} id="Country" name="Country" value={entry.Country}
                                onChange={(event) => this.props.onValueChange("Country", event.target.value)}>
                            <option value={"Israel"}>{t('patient_self_boarding.israel')}</option>
                        </select>

                    </div>

                    <div className={'inputSlots-Select'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}> {t('patient_boarding.cityID')}*</label>
                            <Error isShown={!!(this.props.errors)['cityID']}
                                   errorMessage={(this.props.errors)['cityID']}/>
                        </div>
                        <PatientSelectComponent
                            className={'multipleSelectBox'}
                            placeholder=""
                            options={cities}
                            multiSelect={false}
                            value={entry.SelectedCity}
                            onChange={this.handleCity.bind(this)}
                        />
                    </div>
                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_self_boarding.Street_name')}*</label>
                            <Error isShown={!!(this.props.errors)['Street_name']}
                                   errorMessage={(this.props.errors)['Street_name']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="Street_name" name="Street_nameName"
                               defaultValue={entry.Street_name}
                               maxLength={50}
                               onChange={(event) => this.props.onValueChange("Street_name", event.target.value)}/>
                    </div>
                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_self_boarding.HouseNum')}*</label>
                            <Error isShown={!!(this.props.errors)['House_number']}
                                   errorMessage={(this.props.errors)['House_number']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="text" name="HouseNum" defaultValue={entry.House_number}
                               maxLength={10}
                               onChange={(event) => this.props.onValueChange("House_number", event.target.value)}/>
                    </div>

                </div>
                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.Apartment')}</label>
                        <input className={'inputBoxStyle'} type="text" name="Apartment" value={entry.Apartment}
                               maxLength={10}
                               onChange={(event) => this.props.onValueChange("Apartment", event.target.value)}/>
                    </div>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.postcode')}</label>
                        <input className={'inputBoxStyle'} type="text" name="ZipCode" value={entry.Zip_code}
                               maxLength={10}
                               onChange={(event) => this.props.onValueChange("Zip_code", event.target.value)}/>
                    </div>

                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_self_boarding.mailbox')}</label>
                        <input className={'inputBoxStyle'} type="text" name="MailBox" value={entry.Mail_box}
                               maxLength={10}
                               onChange={(event) => this.props.onValueChange("Mail_box", event.target.value)}/>
                    </div>
                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_self_boarding.Phone_num')}*</label>
                            <Error isShown={!!(this.props.errors)['Phone_num1']}
                                   errorMessage={(this.props.errors)['Phone_num1']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="text" name="Phone_num1" value={entry.Phone_num1}
                               maxLength={20}
                               onChange={(event) => this.props.onValueChange("Phone_num1", event.target.value)}/>
                    </div>

                </div>

                <div className={'patientsFormRow'}>

                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_self_boarding.Add_phone_num')}</label>
                            <Error isShown={!!(this.props.errors)['Phone_num2']}
                                   errorMessage={(this.props.errors)['Phone_num2']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="text" name="AddPhone_num1"
                               value={entry.Phone_num2}
                               maxLength={20}
                               onChange={(event) => this.props.onValueChange("Phone_num2", event.target.value)}/>
                    </div>
                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_self_boarding.Email')}*</label>
                            <Error isShown={!!(this.props.errors)['Email']}
                                   errorMessage={(this.props.errors)['Email']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="email" name="Email" value={entry.Email}
                               maxLength={50}
                               onChange={(event) => this.props.onValueChange("Email", event.target.value)}/>
                    </div>
                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_self_boarding.Additional_Email')}</label>
                        </div>
                        <input className={'inputBoxStyle'} type="email" name="Email" value={entry.Additional_Email}
                               maxLength={50}
                               onChange={(event) => this.props.onValueChange("Additional_Email", event.target.value)}/>
                    </div>

                    <div className={'inputSlots'}>
                        <div className='flex-Display'>
                            <label className={'infoLabel'}>{t('patient_self_boarding.InvoicingName')}</label>
                            <Error isShown={!!(this.props.errors)['InvoicingName']}
                                   errorMessage={(this.props.errors)['InvoicingName']}/>
                        </div>
                        <input className={'inputBoxStyle'} type="text" name="InvoicingName"
                               value={entry.InvoicingName}
                               onChange={(event) => this.props.onValueChange("InvoicingName", event.target.value)}/>
                    </div>

                    </div>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>
                            <label
                                className={'infoLabel-withError'}>{t('patient_self_boarding.BornInIsrael')}?</label>
                        </div>
                        <div className={'inputBoxStyle-yes-no-block'}>

                        <button tabIndex={0}
                                className={entry.BornInIsrael === "Yes" ? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.onclickCountry("Yes")}>{t('patient_self_boarding.yes')}</button>
                        <button tabIndex={0}
                                className={entry.BornInIsrael === "No" ? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.onclickCountry("No")}>{t('patient_self_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                    </div>
                </div>

                {this.props.docWidth<1200 && <div className={'patientsFormRow'}>
                    <div className={'next-Tab-Container'} onClick={()=>this.props.changeTabInternalView(3)}> {t('patient_self_boarding.continue_LifeStyle')}</div>
                </div>}

            </div>

        )
    }
}

LeumitSelfContactDetails.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default LeumitSelfContactDetails;
